export enum ShortAndOverTypes {
  Incremental = 'Incremental',
  Decreasing = 'Decreasing'
}

export enum ShortAndOverSharingTypes {
  Count = "Count",
  Equal = "Equal",
  Price = "Price"
}

export enum ShortAndOverRegistrationTypes {
  Moadian = 'Moadian',
  SeasonalDeals = 'SeasonalDeals'
}

export enum WarehouseTypes {
  Product = 'Product',
  RawMaterial = 'RawMaterial',
  Wastage = 'Wastage',
  HalfMade = 'HalfMade'
}

export enum WarehouseProfitAndLossReportGroupType {
  Product = 'Product',
  MainFloatingCenter = 'MainFloatingCenter',
  Marketer = 'Marketer',
  Company = 'Company',
  ProductGroup = 'ProductGroup',
  Factor = 'Factor',
  FactorBunch = 'FactorBunch',
}

export enum WeightUnit {
  Unknown = 'Unknown',
  Milligram = 'Milligram',
  Gram = 'Gram',
  Kilogram = 'Kilogram',
  Tonne = 'Tonne',
}

export enum VolumeUnit {
  Unknown = 'Unknown',
  Milliliter = 'Milliliter',
  Liter = 'Liter',
  CubicMeter = 'CubicMeter',
  CubicCentimeter = 'CubicCentimeter',
  CubicMillimeter = 'CubicMillimeter',
  Gallon = 'Gallon',
}

export enum DimensionUnit {
  Unknown = 'Unknown',
  Millimeter = 'Millimeter',
  Centimeter = 'Centimeter',
  Meter = 'Meter',
  Kilometer = 'Kilometer',
  Inch = 'Inch'
}

export enum CommissionCalculationType {
	PercentageOfProduct = 'PercentageOfProduct',
	PercentageOfFactor = 'PercentageOfFactor',
	AmountOfFactor = 'AmountOfFactor',
	FixAmount = 'FixAmount',
	FixPercentage = 'FixPercentage',
	FactorProfit = 'FactorProfit',
	Selective = 'Selective'
}